(function () {
  const badgeSel = '#LowStockBadge';

  function getCurrentVariantId() {
    const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input?.value || null;
  }

  async function refreshBadge(variantId) {
    const badge = document.querySelector(badgeSel);
    if (!badge) return;

    const sectionId = badge.dataset.sectionId;
    if (!sectionId) return;

    const url = `${window.location.pathname}?variant=${encodeURIComponent(variantId)}&section_id=${encodeURIComponent(sectionId)}`;
    const res = await fetch(url, { credentials: 'same-origin' });
    const html = await res.text();

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector(badgeSel);
    if (next) badge.replaceWith(next);
  }

  // 1) initial
  const initialId = getCurrentVariantId();
  if (initialId) refreshBadge(initialId);

  // 2) când se schimbă selectorul (multe teme)
  document.addEventListener('change', (e) => {
    if (e.target && (e.target.name === 'id' || e.target.closest('form[action*="/cart/add"]'))) {
      const id = getCurrentVariantId();
      if (id) refreshBadge(id);
    }
  });

  // 3) fallback: unele teme schimbă input-ul fără "change"
  const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
  if (input) {
    const obs = new MutationObserver(() => {
      const id = getCurrentVariantId();
      if (id) refreshBadge(id);
    });
    obs.observe(input, { attributes: true, attributeFilter: ['value'] });
  }

  // 4) fallback 2: dacă tema emite un custom event cu variantă
  document.addEventListener('variant:change', (e) => {
    const id = e?.detail?.variant?.id;
    if (id) refreshBadge(id);
  });
})();